import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API d'authentification
export const authAPI = {
  register: (data: {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    dexcom_username: string;
    dexcom_password: string;
    dexcom_region: string;
  }) => api.post('/auth/register', data),

  login: (data: { email: string; password: string }) =>
    api.post('/auth/login', data),

  getMe: () => api.get('/auth/me'),
};

// API Dexcom
export const dexcomAPI = {
  sync: () => api.post('/dexcom/sync'),
};

// API Hypos
export const hyposAPI = {
  getHypos: (days: number = 30) => api.get(`/hypos?days=${days}`),
  getHypoDetail: (id: number) => api.get(`/hypos/${id}`),
  addTreatment: (hypoId: number, data: {
    treatment_type: string;
    quantity: number;
    unit: string;
    notes?: string;
  }) => api.post(`/hypos/${hypoId}/treatment`, data),
  updateTreatment: (hypoId: number, treatmentId: number, data: {
    treatment_type: string;
    quantity: number;
    unit: string;
    notes?: string;
  }) => api.put(`/hypos/${hypoId}/treatment/${treatmentId}`, data),
};

// API Hypers
export const hypersAPI = {
  getHypers: (days: number = 30) => api.get(`/hypers?days=${days}`),
  getHyperDetail: (id: number) => api.get(`/hypers/${id}`),
};

// API Calendrier
export const calendarAPI = {
  getCalendar: (days: number = 30) => api.get(`/calendar?days=${days}`),
};

// API Paramètres de synchronisation automatique
export const syncSettingsAPI = {
  getSettings: () => api.get('/settings/sync'),
  
  updateSettings: (data: {
    sync_interval_hours?: number;
    auto_sync_enabled?: boolean;
  }) => api.put('/settings/sync', data),
};

export default api;
